<div class="contaoner">
  <p>Loading...</p>
</div>

<style lang="less">
  .contaoner {
    position: relative;
    display: flex;
    flex: auto;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    p {
      font-size: 24px;
    }
  }
</style>
